<template>
    <div>
        <h2>URFO Public Library</h2>
        <p>Scores and (adjusted) parts provided by the URFO and URFO composers-in-residence.</p>
        <!--Works in Public Domain-->
        <h3>Adjusted Scores in Public Domain Once Performed by URFO</h3>
        <!--Works by URFO Composers-in-Residence-->
        <h3>Works commissioned by URFO and Works composed by URFO Composers-in-Residence</h3>
        <p> Unless otherwise noted, URFO and the composer(s) of the works in this section retain all rights to the works. </p>
        <p> We offer rental and purchase options for these works, all profits of which go to the composer(s) and URFO, for the purpose of supporting the creation of new works and offering more performances in the future. </p>
    </div>
</template>

<script>
    export default {
        name: 'LibraryView'
    };
</script>

<style scoped>
    /* Add your styles here */
</style>